import { useLayoutEffect, useState } from 'react';

// Reuse a single span element for all measurements
let measurementSpan: HTMLSpanElement | null = null;

function getMeasurementSpan() {
  if (!measurementSpan) {
    measurementSpan = document.createElement('span');
    measurementSpan.style.position = 'absolute';
    measurementSpan.style.visibility = 'hidden';
    measurementSpan.style.whiteSpace = 'nowrap';
    measurementSpan.style.fontSize = '12px';
    measurementSpan.style.top = '-999px';
    document.body.appendChild(measurementSpan);
  }
  return measurementSpan;
}

export function useTextWidth(text: string, fontWeight: string = 'normal') {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const span = getMeasurementSpan();
    span.style.fontWeight = fontWeight;
    span.textContent = text;

    const measuredWidth = span.getBoundingClientRect().width;
    setWidth(measuredWidth);
  }, [text, fontWeight]);

  return width;
}
// Clean up the measurement span when the app unmounts
if (typeof window !== 'undefined') {
  window.addEventListener('unload', () => {
    if (measurementSpan && measurementSpan.parentNode) {
      measurementSpan.parentNode.removeChild(measurementSpan);
    }
  });
}
